export default __webpack_public_path__ + "static/media/computerScreen2.428bcd16.jpg";